<header _ngcontent-c9="" class="docs-header-background">
  <div _ngcontent-c9="" class="docs-header-section">
    <div _ngcontent-c9="" class="docs-header-headline">
      <h1 _ngcontent-c9="" class="mat-h1">
      <!--  <a routerlink="benchlearning" href="benchlearning" mat-button style='color: rgba(255, 255, 255, 0.87)'>
          <span><i class="material-icons" matTooltip="Benchlearning Overview">arrow_back</i> </span>
        </a>-->
        Benchsimilarity {{compare.curRo.name}} </h1>
    </div>
  </div>
</header>
<span *ngIf="breadcrumVisible1" style="color:#3f51b5; margin-left: 1%" [innerHTML]="breadcrumb1" (click)="getToStartPage()"></span>
<span style="color:#3f51b5;">Similarity</span>
<span *ngIf="breadcrumVisible2" style="color:#3f51b5;" [innerHTML]="breadcrumb2" (click)="onCompareAll()"></span>
<span *ngIf="breadcrumVisible2 && compare.compareRo.name !== 'all'" style="color:#3f51b5;">{{compare.compareRo.name}}</span>


<div class="example-container mat-elevation-z8">
  <mat-card>
    <mat-card-content>
      <span>Compare with</span>
    </mat-card-content>
  <mat-form-field class="input-width">
      <mat-select [(ngModel)]="compare.compareRo"
                  placeholder="RO"
                  id="ro">
        <mat-option *ngFor="let ro of compare.ros" [value]="ro">
          {{ro.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-mini-fab color="primary" matTooltip="start compare" (click)="prepareCompare()" style="margin:5px;"><mat-icon aria-label="filter">done</mat-icon></button>

  </mat-card>
  <div style="width: 100%; " *ngIf="tableVisible">

    <mat-card style="margin-bottom: 50px">
  <!--    <button  mat-mini-fab color="primary" matTooltip="Info about Pearson and used fields" (click)="openDialogInfo()" style="margin:5px; float: right;">
        <mat-icon aria-label="info">info</mat-icon>
      </button>-->

      <div [chart]="chart"></div>

    </mat-card>
  </div>
  <mat-card>
    <table class="table" matSort (matSortChange)="sortData($event)" *ngIf="tableVisible">
      <tr>
        <th mat-sort-header="Name">Name</th>
        <th mat-sort-header="Pearson">Total</th>
        <th mat-sort-header="Euclidean">Basic Info</th>
        <th mat-sort-header="Jaccard">Customer Segment</th>
        <th mat-sort-header="Hamann" >Value Proposition</th>
        <th mat-sort-header="2">Key Resources</th>
        <th mat-sort-header="3">Key Partners</th>
        <th mat-sort-header="4">Customer Relationships</th>
        <th mat-sort-header="5">Channels</th>
      </tr>
      <tr *ngFor="let element of similarityRes">
        <td>{{element.obsName}}</td>
        <td>{{element.results[7].toFixed(3)}}</td>
        <td>{{element.results[0].toFixed(3)}}</td>
        <td>{{element.results[1].toFixed(3)}}</td>
        <td>{{element.results[2].toFixed(3)}}</td>
        <td>{{element.results[3].toFixed(3)}}</td>
        <td>{{element.results[4].toFixed(3)}}</td>
        <td>{{element.results[5].toFixed(3)}}</td>
        <td>{{element.results[6].toFixed(3)}}</td>

      </tr>
    </table>
  </mat-card>

  <mat-card style="margin-bottom: 100px;">
    <h4 style=" margin-left: 3px;">Information about Pearson</h4>
    <p>The aim of the diagram is to show the similarity between all ROs and the single RO, which was selected. If one RO is clicked
      or selected in the drop down menu, the single sections are presented in comparison to the sections of the preselected RO.</p>
    <h5>Pearson:</h5>
    <p>In statistics, the Pearson correlation coefficient is a measure of the linear correlation between two variables X and Y.
      It gives information about the magnitude of the association, or correlation, as well as the direction of the relationship.
      The result is a value between +1 and −1, where 1 is total positive linear correlation, 0 is no
      linear correlation, and −1 is total negative linear correlation. </p>
    <span>A correlation coefficient indicates the extent to which dots in a scatterplot lie on a straight line.</span>
    <li>Correlations are never lower than -1. A correlation of -1 indicates that the data points in a scatter plot lie exactly on a straight descending line; the two variables are perfectly negatively linearly related.</li>
    <li>A correlation of 0 means that two variables don't have any linear relation whatsoever. However, some non linear relation may exist between the two variables.</li>
    <li> Correlation coefficients are never higher than 1. A correlation coefficient of 1 means that two variables are perfectly positively linearly related; the dots in a scatter plot lie exactly on a straight ascending line.</li>
  </mat-card>

</div>
